import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SsoLoginComponent } from './sso-login/sso-login.component';
import { AuthCallbackComponent } from './sso-login/auth-callback.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '../core/guards/auth.guard';
import {AuthLogoutComponent} from "./sso-login/auth-logout.component";
import {ChangePasswordComponent} from "@app/modules/change-password/change-password.component";
import {ForgotPasswordComponent} from "@app/modules/forgot-password/forgot-password.component";
import {Verify2faComponent} from "@app/modules/verify-2fa/verify-2fa.component";
import {Setup2faComponent} from "@app/modules/setup-2fa/setup-2fa.component";
import {RecoveryRequestComponent} from "@app/modules/recovery-request/recovery-request.component";
import {ConfirmContactComponent} from "@app/modules/confirm-contact/confirm-contact.component";
import { ProfileComponent } from "@app/modules/profile/profile.component";
import { SsoDiagramComponent } from './dashboard/components/sso-diagram/sso-diagram.component';
import { SsoUserGuideComponent } from './dashboard/components/sso-user-guide/sso-user-guide.component';

const routes: Routes = [
  {
    path: 'login',
    component: SsoLoginComponent
  },
  {
    path: 'confirm-contact',
    component: ConfirmContactComponent
  },
  {
    path: 'verify-2fa',
    component: Verify2faComponent
  },
  {
    path: 'setup-2fa',
    component: Setup2faComponent
  },
  {
    path: 'recovery-request',
    component: RecoveryRequestComponent
  },
  {
    path: 'callback',
    component: AuthCallbackComponent
  },
  {
    path: 'logout',
    component: AuthLogoutComponent
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'users',
        loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'user-accounts',
        loadChildren: () => import('./user-accounts/user-accounts.module').then((m) => m.UserAccountsModule),
      },
      {
        path: 'projects',
        loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
      },
      {
        path: 'audit-logs',
        loadChildren: () => import('./audit-logs/audit-logs.module').then((m) => m.AuditLogsModule),
      },
      {
        path: 'system-admin',
        loadChildren: () => import('./system-admin/system-admin.module').then((m) => m.SystemAdminModule),
      },
      {
        path: 'notifications',
        loadChildren: () => import('./notifications/notifications.module').then((m) => m.NotificationsModule),
      },
      {
        path: 'announcements',
        loadChildren: () => import('./announcements/announcements.module').then((m) => m.AnnouncementsModule),
      },
      {
        path: 'asked-questions',
        loadChildren: () => import('./asked-questions/asked-questions.module').then((m) => m.AskedQuestionsModule),
      },
      {
        path: 'usage-guide',
        loadChildren: () => import('./usage-guide/usage-guide.module').then((m) => m.UsageGuideModule),
      },
      {
        path: 'sso-diagram',
        component: SsoDiagramComponent,
      },
      {
        path: 'sso-user-guide',
        component: SsoUserGuideComponent,
      },
      {
        path: 'admin/asked-questions',
        redirectTo: '/asked-questions/admin',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'my-systems',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
];

@NgModule({
  
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  
})
export class FeatureRoutingModule { }


